import { useMemo } from 'react';
import useStrategyDefaultAsset from 'personalization-lib/hooks/contentEditor/useStrategyDefaultAsset';
import { getAssetDataWithDefaultOverride } from 'personalization-lib/utils/contentEditor';
/**
 * Hook that returns the asset data, overridden with the default asset data if a variant in a strategy is passed.
 * @param assetData - Data for the asset being viewed in the content editor.
 * @returns Memoized object containing the asset data, loading state, and any error encountered.
 */
const useAssetDataWithDefaultOverride = ({
  assetType,
  assetId,
  assetName,
  strategyId
}) => {
  const {
    defaultAsset,
    loading,
    error
  } = useStrategyDefaultAsset(strategyId, assetId);
  const assetData = useMemo(() => ({
    assetType,
    strategyId,
    assetName,
    assetId
  }), [assetType, strategyId, assetName, assetId]);
  return useMemo(() => ({
    assetData: !loading && !error ? getAssetDataWithDefaultOverride(assetData, defaultAsset) : undefined,
    loading,
    error
  }), [loading, error, assetData, defaultAsset]);
};
export default useAssetDataWithDefaultOverride;